/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingAddress
 */
export interface BillingAddress {
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    building: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    street1: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    street2: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    countryCode: string;
}

/**
 * Check if a given object implements the BillingAddress interface.
 */
// @ts-ignore
export function instanceOfBillingAddress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "building" in value;
    isInstance = isInstance && "street1" in value;
    isInstance = isInstance && "street2" in value;
    isInstance = isInstance && "postalCode" in value;
    isInstance = isInstance && "region" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "countryCode" in value;

    return isInstance;
}

// @ts-ignore
export function BillingAddressFromJSON(json: any): BillingAddress {
    return BillingAddressFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingAddress {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'building': json['building'],
        'street1': json['street1'],
        'street2': json['street2'],
        'postalCode': json['postal_code'],
        'region': json['region'],
        'city': json['city'],
        'countryCode': json['country_code'],
    };
}

// @ts-ignore
export function BillingAddressToJSON(value?: BillingAddress | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'building': value.building,
        'street1': value.street1,
        'street2': value.street2,
        'postal_code': value.postalCode,
        'region': value.region,
        'city': value.city,
        'country_code': value.countryCode,
    };
}

